
import { Alert, Space, Tabs} from 'antd';

import { TopicContextProvider } from '@/context/topicContext/topicContext';
import HighlightedTopicsTable from '@Components/Tables/HighlightedTopicsTable';
import OrderFeaturedTopics from '../components/Tables/OrderFeaturedTopics';

export default function FeaturedTopics() {

    const items = [
        {
            key: '1',
            label: 'FEATURED TOPICS',
            children: <OrderFeaturedTopics />,
            destroyInactiveTabPane: true,
        },
        {
            key: '2',
            label: 'ALL TOPICS',
            children: <HighlightedTopicsTable />,
            destroyInactiveTabPane: true,
        },
    ];

	return (
		<TopicContextProvider edit>
			<Space size="large" direction='vertical' style={{width: '100%'}} >
				<h1>{`Homepage > Featured Topics`}</h1>
			</Space>
            <Alert
                description={
                    <>To display this section in the homepage, you must select between 4 and 6 items. </>}
                type="info"
                style={{marginBottom: 20}}
            />

            <Tabs defaultActiveKey="1" items={items} type="card" size="large"/>
		</TopicContextProvider>
	);
}